import { format } from 'date-fns'
import { enUS, sv } from 'date-fns/locale'
import { fromZonedTime } from 'date-fns-tz'
import { toZonedTime } from 'date-fns-tz/toZonedTime'
import type { DateTime } from 'patient-api-lib'
import { getI18n } from 'react-i18next'

import { DEFAULT_TIMEZONE } from '@/constants/app'
import { LANGUAGE } from '@/i18n/config'

export const protoToDate = (protoDate: DateTime.AsObject) => {
  const date = new Date(
    +protoDate.year,
    +protoDate.month - 1,
    +protoDate.day,
    +protoDate.hours,
    +protoDate.minutes,
    +protoDate.seconds,
    +protoDate.nanos
  )

  return date
}

export const convertToZonedDate = (date: Date) => {
  return toZonedTime(date, DEFAULT_TIMEZONE)
}

export const protoToZonedTimeDate = (protoDate: DateTime.AsObject) => {
  return fromZonedTime(protoToDate(protoDate), protoDate.timeZone?.id || DEFAULT_TIMEZONE)
}

export const formatDate = (protoDate: DateTime.AsObject | undefined, dateFormat: string) => {
  if (!protoDate) return null
  const convertDate = protoToDate(protoDate)
  const i18n = getI18n()
  const locale = i18n.resolvedLanguage === LANGUAGE.SV ? sv : enUS
  return format(convertDate, dateFormat, { locale })
}
